export function safePortalReturn(value, origin = window.location.origin) {
  if (typeof value !== 'string' || !value.toLowerCase().startsWith('/portal/')
      || value.includes('\\') || /[\u0000-\u001f\u007f]/.test(value)) return null
  try {
    const url = new URL(value, origin)
    return url.origin === origin && url.pathname.toLowerCase().startsWith('/portal/')
      ? url.pathname + url.search + url.hash : null
  } catch { return null }
}

export function loginDestination(path = window.location.pathname + window.location.search + window.location.hash) {
  const target = safePortalReturn(path)
  return target ? '/login?returnTo=' + encodeURIComponent(target) : '/login'
}
